import { useState } from "react";
import { initials } from "../lib/people.ts";
import { cn } from "../lib/utils.ts";

/**
 * Marca do cliente: logomarca quando existe, iniciais coloridas no fallback.
 *
 * No `/@handle` este é o ícone local — aba, PIN e calendário — no lugar da
 * marca da Dream Calendar.
 */

export function ClientMark({
  name,
  color,
  logoUrl,
  size = 40,
  alt,
}: {
  name: string;
  color: string;
  logoUrl?: string | null;
  size?: number;
  alt?: string;
}) {
  const [failed, setFailed] = useState(false);
  const showImage = logoUrl !== null && logoUrl !== undefined && logoUrl !== "" && !failed;
  const shape = size >= 64 ? "rounded-2xl" : "rounded-xl";

  if (showImage) {
    return (
      <img
        src={logoUrl}
        alt={alt ?? ""}
        width={size}
        height={size}
        data-testid="client-mark"
        draggable={false}
        onError={() => setFailed(true)}
        className={cn(
          "shrink-0 bg-white object-contain p-1 ring-1 ring-[var(--color-line)]",
          shape,
        )}
        style={{ width: size, height: size }}
      />
    );
  }

  return (
    <span
      data-testid="client-mark"
      aria-hidden={alt === undefined}
      className={cn("inline-flex shrink-0 items-center justify-center font-bold text-white", shape)}
      style={{ width: size, height: size, backgroundColor: color, fontSize: size * 0.36 }}
    >
      {alt !== undefined ? <span className="sr-only">{alt}</span> : null}
      {initials(name)}
    </span>
  );
}
